module.exports = __webpack_public_path__ + "img/aside-right-board.9707243a.png";